/**
 * WaitlistGate — shown to signed-in users who are on the waitlist (restricted access).
 * Extracted from PrimateVisionV2.tsx (PRI-291 Phase 5)
 */
// R14 (PRI-439): moved out of src/core — waitlist UX + Darwin brand asset are
// app-plane (§23 non-goals: brand identity never enters the OSS package).
import { L } from '../../core/components/v2/pv2-shared'

interface WaitlistGateProps {
  onSignOut: () => void
}

export function WaitlistGate({ onSignOut }: WaitlistGateProps) {
  return (
    <div style={{ minHeight: '100dvh', background: L.bgPrimary, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 48 }}>
        <img src="/Darwin_v3_vinyl_transparent.png" alt="" style={{ height: 40, width: 'auto', objectFit: 'contain' }} />
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
          <span style={{ fontSize: 18, fontWeight: 300, color: L.textPrimary, letterSpacing: '-0.025em' }}>Primate</span>
          <span style={{ fontSize: 18, fontWeight: 300, color: L.signal, letterSpacing: '-0.025em' }}>Intelligence</span>
        </div>
      </div>
      <div data-testid="waitlist-gate" style={{ maxWidth: 400, width: '100%', background: L.bgSurface, border: `1px solid ${L.border}`, borderRadius: 16, padding: '40px 32px', textAlign: 'center', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>⏳</div>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: L.textPrimary, marginBottom: 12, margin: '0 0 12px' }}>You&apos;re on the waitlist</h2>
        <p style={{ fontSize: 15, color: L.textMuted, lineHeight: 1.6, margin: '0 0 24px' }}>
          Your account is pending approval. We&apos;ll email you when you&apos;re approved for access.
        </p>
        <button
          onClick={() => { if (typeof onSignOut === 'function') void onSignOut(); }}
          style={{ fontSize: 13, color: L.signal, background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
